"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseBackground = exports.ContentLayer = exports.BackgroundLayer = exports.BackgroundImageWrapper = exports.BgImage = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gridContainer = require("../grid-container");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BgImage = (0, _styledComponents["default"])('div').withConfig({
  displayName: "layered-dialogstyle__BgImage",
  componentId: "sc-1453c6o-0"
})(["border-radius:50%;overflow:hidden;position:absolute;left:-75px;bottom:-20px;width:300px;height:300px;display:flex;img{max-width:unset;}"]);
exports.BgImage = BgImage;
var BackgroundImageWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "layered-dialogstyle__BackgroundImageWrapper",
  componentId: "sc-1453c6o-1"
})(["grid-column:col-start 1 / col-end 6;position:relative;min-height:400px;overflow:hidden;"]);
exports.BackgroundImageWrapper = BackgroundImageWrapper;
var BackgroundLayer = (0, _styledComponents["default"])(_gridContainer.GridContainerWithBackground).withConfig({
  displayName: "layered-dialogstyle__BackgroundLayer",
  componentId: "sc-1453c6o-2"
})(["display:none;@media ", "{display:block;left:-", "px;top:calc(20% + ", "px);right:0;width:45%;max-width:800px;position:absolute;margin-left:auto;margin-right:auto;z-index:1;}"], function (props) {
  return props.theme.queries.tabletAndUp;
}, function (props) {
  return props.offsetHorizontal / 2;
}, function (props) {
  return props.offsetVertical / 2;
});
exports.BackgroundLayer = BackgroundLayer;
var ContentLayer = (0, _styledComponents["default"])(_gridContainer.GridContainer).withConfig({
  displayName: "layered-dialogstyle__ContentLayer",
  componentId: "sc-1453c6o-3"
})(["max-width:95%;padding:24px;position:absolute;background:white;min-height:400px;box-shadow:", ";border-radius:6px;right:0;left:0;top:50%;transform:translateY(-50%);margin-left:auto;margin-right:auto;z-index:2;@media ", "{width:40%;max-width:800px;left:", "px;top:calc(20% - ", "px);transform:none;}"], function (props) {
  return props.theme.effects.boxShadow.cards;
}, function (props) {
  return props.theme.queries.tabletAndUp;
}, function (props) {
  return props.offsetHorizontal / 2;
}, function (props) {
  return props.offsetVertical / 2;
});
exports.ContentLayer = ContentLayer;
var CloseBackground = (0, _styledComponents["default"])('button').withConfig({
  displayName: "layered-dialogstyle__CloseBackground",
  componentId: "sc-1453c6o-4"
})(["position:absolute;left:0;top:0;width:100%;height:100%;background:", ";opacity:0.2;border:none;z-index:0;"], function (props) {
  return props.overlayColor;
});
exports.CloseBackground = CloseBackground;